import React from 'react';
import {Button} from '@yandex-data-ui/common';
import block from 'bem-cn-lite';

import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';

import './TranslateDemoError.scss';

const b = block('TranslateDemoError');

interface TranslateDemoErrorProps extends WithTranslationProps {
    handleClick: () => void;
}

const TranslateDemoError: React.FC<TranslateDemoErrorProps> = ({children, handleClick, i18nK}) => {
    return (
        <div className={b()}>
            <div>{children}</div>
            <Button view="outlined" size="l" onClick={handleClick} className={b('button')}>
                {i18nK('error-try_again')}
            </Button>
        </div>
    );
};

export default withTranslation('translate-demo')(TranslateDemoError);
